<template>
    <div class="final">
        <div :winsorfail="winsorfail" :class="`final-texto ${etapa}`">
           {{texto}}
        </div>

        <button v-on:click="jogarNovamente" class="final-botao">Jogar novamente</button>
    </div>
</template>

<script>

export default{
    name: 'Jogo',
    props:{
        etapa: String,
        texto: String,
        jogarNovamente: Function,
        winsorfail: Boolean
    },
   
    created(){    
     
        var fail = new Audio('./songs/gameover.mp3');
        var wins = new Audio('./songs/wins.mp3');
        
        if(this.winsorfail == true){
        fail.play();
        }
        else{
         wins.play();
        }

    },
}
</script>

<style scoped>

    .final-texto{
        font-size: 30px;
        font-weight: bold;
        margin:40px 0;
        text-align: center;
    }

    .final-texto.enforcado{
        color: rgb(246, 2, 2);
    }
    
    .final-texto.ganhador{
     text-shadow: 3px 2px 1px rgba(41, 218, 25, 0.3);
     color:#3aff33;
    }
     .final-botao{
        padding: 13px 28px;
        background: var(--color-background-button);
        color: rgb(255, 255, 255);
        outline: none;
        border:0;
        font-size: 17px;
        border-radius: 4px; 
        font-weight: bold;
        border:2px solid;  
        cursor: pointer;
        box-shadow: 1px 2px 1px 3px rgba(18, 43, 184, 0.1);
        transition: ease-in-out 0.3s;
        position: relative;
        overflow:hidden;
        background:linear-gradient(rgba(14, 13, 13, 0.63),rgb(0, 0, 0));
        z-index: 0;
    }
    .final-botao::before{
    content:'';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: -1;
    clip-path: polygon(0 0, 100% 0, 0 0, 0% 100%);
    transition:.3s linear;
    background:linear-gradient(150deg,rgb(173, 6, 159),rgba(231, 0, 181, 0.281));
}

.final-botao:hover::before{
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
}

</style>
